
import Vue from 'vue';
import { StatValue } from '@/generated-clients/bff';
import { Component, Prop } from 'vue-property-decorator';
import ChevronRight from '@components/icons/icon-chevron-right.svg';
import StatValueDisplay from '@components/statistic/StatValueDisplay.vue';

@Component({
  name: 'StatisticItem',
  components: {
    ChevronRight,
    StatValueDisplay
  }
})
export default class StatisticItem extends Vue {
  @Prop({ required: true })
  private name: string;

  @Prop({ required: true })
  private statValue: StatValue;

  @Prop()
  private tripId: number;

  @Prop()
  private loading: boolean;

  get tripLink() {
    return { name: 'myTripsEdit', params: { id: this.tripId.toString(), fromStatistic: 'true' } };
  }
}
